export const getBaseUrl = (): string =>
    `${window.location.protocol}//${window.location.host}${window?.DYDU_TARGETS?.on_atria ? '/bms-front' : ''}`;